import { render, staticRenderFns } from "./MljyMessage.vue?vue&type=template&id=aa76c008&scoped=true&"
import script from "./MljyMessage.vue?vue&type=script&lang=js&"
export * from "./MljyMessage.vue?vue&type=script&lang=js&"
import style0 from "./MljyMessage.vue?vue&type=style&index=0&id=aa76c008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa76c008",
  null
  
)

export default component.exports